<template>
	<layout>
		<roles :id="id"></roles>
	</layout>
</template>

<script>
	import layout from '../layout/layout.vue'
	import roles from '../components/roles.vue'
	export default {
		name: 'role',
		
		props:{
			id:{
				required: false,
				default: false
			},
		},
		components:{
			layout,
			roles,
		},
		
		data () {
			return {

			}
		}
	}
</script>

<style lang="css" scoped>
</style>